/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 05 2024
 **/

import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import ClipLoader from "react-spinners/ClipLoader";

import { ZIndex } from "@/frameworks/core/commons";
import { Column } from "@/frameworks/designStuff/components";

export default function Spinner() {
	const theme = useTheme();

	return (
		<SpinnerWrapper>
			<ClipLoader
				color={theme.colors.accent_40_100}
				size={24}
				speedMultiplier={1}
				cssOverride={{
					borderWidth: "4px",
					borderColor: `${theme.colors.accent_40_100} ${theme.colors.accent_40_100} ${theme.colors.neutral_30_100} ${theme.colors.neutral_30_100}`
				}}
			/>
		</SpinnerWrapper>
	);
}

const SpinnerWrapper = styled(Column)`
	position: absolute;
	top: 20px;
	left: 50%;
	transform: translateX(-50%);
	padding: 8px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.neutral_00_88};
	filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.2)) drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.04));
	z-index: ${ZIndex.CHAT_POPUP};
`;
